import {
  Fancybox
} from "@fancyapps/ui/src/Fancybox/Fancybox.js"

let pageItems = []

export default {
  install(Vue, options) {
    Vue.directive('fancy-box', {
      bind: function (el, binding, vnode) {
        const defaultOptions = {
          dragToClose: false,
          closeButton: 'outside',
          template: {
            closeButton: `<i class="icon-close"></i><span>CLOSE</span>`,
            main: `
                  <div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1">
                      <div class="fancybox__backdrop"></div>
                      <div class="fancybox__carousel"></div>
                      <img src="/public/site/${process.env.MIX_TEMPLATE_FOLDER}/dist/images/logo.png" class="logo">
                  </div>
              `,
          },
          Carousel: {
            Navigation: {
              prevTpl: `<i class="icon-arrow-slim-left">`,
              nextTpl: `<i class="icon-arrow-slim-right">`,
            }
          },
          Thumbs: {
            autoStart: false,
          },
          Toolbar: {
            display: [],
          },
        }

        let galleryOptions
        galleryOptions = Object.assign(defaultOptions, options)

        if (binding.value) {
          galleryOptions = Object.assign(options, binding.value)
        }

        if (el.getAttribute('title')) {
          galleryOptions = Object.assign(galleryOptions, {
            on: {
              initLayout: (fancybox) => {
                document.querySelectorAll('.fancybox__title')[0].innerHTML = el.getAttribute('title')
              }
            }
          })
        }

        pageItems.push(vnode)

        el.addEventListener("click", function (event) {

          event.preventDefault()

          let directives = [],
            items = [],
            index = 0,
            $target = event.currentTarget.blur();

          if (binding.arg) {
            directives = pageItems.filter(directive => directive.data.directives[0].arg === binding.arg)
          } else {
            items.push({
              src: el.getAttribute('href'),
            })
          }

          directives.forEach(function (item, i) {
            items.push({
              src: item.elm.getAttribute('href'),
            })

            // if (item.elm === $target[0]) {
            //   index = i
            // }
          })

          Fancybox.show(items, galleryOptions);
        });
      },
      inserted: function (el) {}
    })
  }
};